import { SelectUserModule } from './../../select-user/select-user.module';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SpaceAssignmentEditComponent } from './space-assignment-edit.component';
import { SelectDropdownModule } from 'src/app/app/_component/select-dropdown/select-dropdown.module';
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
} from '@danielmoncada/angular-datetime-picker';
import { LoadingStiModule } from 'src/app/_component/loading-sti/loading-sti.module';
import { ModalHeaderComponentModule } from 'src/app/app/_component/modal-header/modal-header.module';
import { DateTimePickerComponentModule } from '../../date-time-picker/date-time-picker.module';
import { InputsModule } from 'src/app/_component/inputs/inputs.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule,
    RouterModule,
    SelectDropdownModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    LoadingStiModule,
    ModalHeaderComponentModule,
    DateTimePickerComponentModule,
    InputsModule,
    SelectUserModule,
  ],

  declarations: [SpaceAssignmentEditComponent],
  exports: [SpaceAssignmentEditComponent],
})
export class SpaceAssignmentEditModule {}
